import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';


export const SmsConfiguartionInfoComponent = ({ selectedSmsConfigurations, handleInnerFormChange }: any) => {

  return (
    <>
      
     
      <AccordionContainer
              child={
                <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
      
                   <InputContainer
                    label="Service Provider"
                    labelField="ServiceProvider"
                    onValueChange={(event: any, newValue: any) => {
                      handleInnerFormChange(
                        event.target.value,
                        'GreenAdsGlobal.ServiceProvider',
                        selectedSmsConfigurations?.GreenAdsGlobal,
                      );
                    }}
                    type="text"
                    value={selectedSmsConfigurations?.GreenAdsGlobal?.ServiceProvider}
                  />
      
      
                  
                   <InputContainer
                    label="Api Key"
                    labelField="ApiKey"
                    onValueChange={(event: any, newValue: any) => {
                      handleInnerFormChange(
                        event.target.value,
                        'GreenAdsGlobal.ApiKey',
                        selectedSmsConfigurations?.GreenAdsGlobal,
                      );
                    }}
                    type="text"
                    value={selectedSmsConfigurations?.GreenAdsGlobal?.ApiKey}
                  />
      
                  <InputContainer
                    label="Domain Name"
                    labelField="DomainName"
                    onValueChange={(event: any, newValue: any) => {
                      handleInnerFormChange(
                        event.target.value,
                        'GreenAdsGlobal.DomainName',
                        selectedSmsConfigurations?.GreenAdsGlobal,
                      );
                    }}
                    type="text"
                    value={selectedSmsConfigurations?.GreenAdsGlobal?.DomainName}
                  />
      
                  <InputContainer
                    label="SenderName"
                    labelField="SenderName"
                    onValueChange={(event: any, newValue: any) => {
                      handleInnerFormChange(
                        event.target.value,
                        'GreenAdsGlobal.SenderName',
                        selectedSmsConfigurations?.GreenAdsGlobal,
                      );
                    }}
                    type="text"
                    value={selectedSmsConfigurations?.GreenAdsGlobal?.SenderName}
                  />
      
                   <InputContainer
                    label="Route Type"
                    labelField="RouteType"
                    onValueChange={(event: any, newValue: any) => {
                      handleInnerFormChange(
                        event.target.value,
                        'GreenAdsGlobal.RouteType',
                        selectedSmsConfigurations?.GreenAdsGlobal,
                      );
                    }}
                    type="text"
                    value={selectedSmsConfigurations?.GreenAdsGlobal?.RouteType}
                  />
      
                  <InputContainer
                    label="tid"
                    labelField="tid"
                    onValueChange={(event: any, newValue: any) => {
                      handleInnerFormChange(
                        event.target.value,
                        'GreenAdsGlobal.tid',
                        selectedSmsConfigurations?.GreenAdsGlobal,
                      );
                    }}
                    type="text"
                    value={selectedSmsConfigurations?.GreenAdsGlobal?.tid}
                  />

                  <InputContainer
                    label="Activated Date"
                    labelField="ActivatedDate"
                    onValueChange={(event: any, newValue: any) => {
                      handleInnerFormChange(
                        event.target.value,
                        'GreenAdsGlobal.ActivatedDate',
                        selectedSmsConfigurations?.GreenAdsGlobal,
                      );
                    }}
                    type="date"
                    value={selectedSmsConfigurations?.GreenAdsGlobal?.ActivatedDate}
                  />

                 <InputContainer
                    label="Active"
                    name="IsActive"
                    onValueChange={(event: any) => {
                      handleInnerFormChange(
                        event,
                        'GreenAdsGlobal.IsActive',
                        selectedSmsConfigurations?.GreenAdsGlobal
                      )
                    }}
                    type="checkbox"
                    value={selectedSmsConfigurations?.GreenAdsGlobal?.IsActive}
                  />
      
      
                </div>
              }
              expandedPanel="GreenAdsGlobal"
              headerTitle="Green Ads Global"
            />
 <AccordionContainer
              child={
                <div className='cols-span-full'>
      
                   <InputContainer
                   readOnly
                    label="Balance Info"
                    labelField="BalanceInfo"
                    onValueChange={(event: any) => {
                      // handleInnerFormChange(
                      //   event,
                      //   'GreenAdsGlobal.BalanceInfo',
                      //   selectedSmsConfigurations?.GreenAdsGlobal,
                      // );
                    }}
                    type="rte"
                    value={selectedSmsConfigurations?.GreenAdsGlobal?.BalanceInfo}
                  />
      
      
                  
                 
      
      
                </div>
              }
              expandedPanel="BalanceInfo"
              headerTitle="Balance Info"
            />

            <AccordionContainer
              child={
                <div className='cols-span-full'>
      
                   <InputContainer
                    readOnly
                    label="Delivery Report"
                    labelField="DeliveryReport"
                    onValueChange={(event: any, newValue: any) => {
                      // handleInnerFormChange(
                      //   event,
                      //   'GreenAdsGlobal.DeliveryReport',
                      //   selectedSmsConfigurations?.GreenAdsGlobal,
                      // );
                    }}
                    type="rte"
                    value={selectedSmsConfigurations?.GreenAdsGlobal?.DeliveryReport}
                  />
 
      
                </div>
              }
              expandedPanel="DeliveryReport"
              headerTitle="Delivery Report"
            />
      
    </>
  )
}
export default SmsConfiguartionInfoComponent;
